import { useState } from "react";
import { toast } from "react-toastify";
import { useMutation } from "react-query";
//primereact
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { confirmDialog } from "primereact/confirmdialog";
//components
import Panel from "../../../components/panel/panel";
//utils
import { queryClient } from "../../../utils/queryClient";
//services
import { putCostCenter } from "../../../services/CostCenter/putCostCenter";
import { deleteCostCenter } from "../../../services/CostCenter/deleteCostCenter";
import ModalViewInstallments from "./ModalViewInstallments";
import { banks } from "../../../utils/banks";

export const TableData = ({ dataTable }) => {


  const [id, setId] = useState(null);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [viewInstallments, setViewInstallments] = useState([])


  const getBankLabel = (bankCode) => {
    const bank = banks.find(b => b.value === bankCode);
    return bank ? bank.label : 'Banco não encontrado'; // Retorna o nome do banco ou uma mensagem padrão se não encontrado
  };

  const formatDateHours = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };


  const columns = [
    { field: "shipping_code", header: "Nº da remessa" },
    {
      field: "created_at", header: "Data de Geração",
      body: (rowData) => {
        return formatDateHours(rowData.created_at)
      }
    },
    {
      field: "account", header: "Conta Corrente",
      body: (rowData) => {
        const accountData = rowData.current_account;
        const bankLabel = getBankLabel(accountData.bank); // Obtenha o nome do banco
        return `${bankLabel} | Agência: ${accountData.agency} - ${accountData.agency_digit} | Conta: ${accountData.account_number} - ${accountData.account_digit}`;
      }
    },
    {
      field: "views",
      header: "Visualizar",
      body: (rowData) => {
        return (
          <>
            <div className="d-flex justify-content-around">
              <div className="text-center">
                <button
                  className="btn btn-info btn-btn-sm"
                  onClick={() => handleView(rowData)}
                >
                  <i className="fa-solid fa-eye"></i>
                </button>
              </div>
            </div>
          </>
        );
        // }
      },
    },
  ];
  const handleView = ((rowData) => {
    setViewInstallments(rowData);

    setVisible(true)
  })

  // put cost center
  const { mutateAsync: putCostCenterFn } = useMutation({
    mutationFn: putCostCenter,
    onSuccess(_, variables) {
      variables.id = id;
      queryClient.setQueryData(["cost-center"], (data) => {
        const updatedTable = data.map((item) => {
          if (item.id === id) {
            item.ref = variables.ref;
            item.desc = variables.desc;
          }

          return item;
        });

        return [...updatedTable];
      });
    },
    onError(error) {
      //      console.log(error);
    },
  });

  // delete cost center
  const { mutateAsync: deleteCostCenterFn } = useMutation({
    mutationFn: deleteCostCenter,
    onSuccess(_, variables) {
      //      console.log(variables);
      queryClient.setQueryData(["cost-center"], (data) => {
        const updatedTable = data.filter((item) => item.id !== variables);

        return [...updatedTable];
      });
    },
    onError(error) {
      //      console.log(error);
    },
  });

  // delete cost
  const handleDeleteCost = (rowData) => {
    confirmDialog({
      message: "Deseja fazer a exclusão?",
      header: "Confirmação",
      icon: "pi pi-info-circle",
      defaultFocus: "reject",
      acceptClassName: "p-button-danger",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => deleteCost(rowData.id),
    });
  };

  const deleteCost = async (id) => {
    setLoading(true);

    const notification = toast.loading("Deletando...");
    try {
      const response = await deleteCostCenterFn(id);
      //      console.log(response);

      toast.update(notification, {
        render: response.success,
        type: "success",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
    } catch (e) {
      //      console.log(e);
      toast.update(notification, {
        render: "Houve um erro a buscar os dados, tente novamente",
        type: "error",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
    } finally {
      setLoading(false);
      setVisible(false);
    }
  };



  return (
    <Panel mainCss="mt-4" title="Remessas Geradas">
      <>
        <div className="px-2 pb-3">
          <DataTable
            rows={10}
            paginator
            stripedRows
            showGridlines
            sortMode="multiple"
            selectionMode="single"
            globalFilter={globalFilterValue}
            rowsPerPageOptions={[10, 25, 100]}
            value={dataTable}
            emptyMessage="Nenhuma Informação foi encontrada."
            tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
          >
            {columns.map((col, i) => (
              <Column
                sortable
                body={col.body}
                key={i}
                style={{ minWidth: 150 }}
                field={col.field}
                header={col.header}
              />
            ))}
          </DataTable>
        </div>
        <ModalViewInstallments
          setVisible={setVisible}
          visible={visible}
          viewInstallments={viewInstallments}


        />
      </>
    </Panel>
  );
};
